import Dashboard from 'modules/Dashboard/Dashboard';
import Home from 'modules/Home/Home';
import UsersPage from 'modules/Users/UsersPage';
import CreateOrEditUser from 'modules/Users/createUser/CreateOrEditUser';
import UserStatsPage from 'modules/Users/userStats/UserStatsPage';

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { HistoryRouter } from 'redux-first-history/rr6';
import PrivateRoute from 'shared/routes/privateRoute';
import { history } from 'store';

const Routing: React.FC = () => {
  return (
    <HistoryRouter history={history}>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UsersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/:id/stats"
          element={
            <PrivateRoute>
              <UserStatsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/:id"
          element={
            <PrivateRoute>
              <CreateOrEditUser />
            </PrivateRoute>
          }
        />
      </Routes>
    </HistoryRouter>
  );
};

export default Routing;
